import { useInfiniteQuery } from 'react-query';

import {
  SubscriberCommentsParams,
  SubscriberCommentsResponse,
  getPaginatedSubscriberComments,
} from '../utils/backend-api/subscriber_directory';

interface SubscriberCommentsHookParams {
  userId?: SubscriberCommentsParams['user_id'];
  username?: SubscriberCommentsParams['username'];
  commentType: SubscriberCommentsParams['comment_type'];
}

const generateSubscriberCommentsKey = ({
  commentType,
  userId,
  username,
}: SubscriberCommentsHookParams) => ['subscriberComments', commentType, userId, username];

export default function useSubscriberComments({
  commentType,
  userId,
  username,
}: SubscriberCommentsHookParams) {
  const { data, isLoading, isFetching, fetchNextPage, hasNextPage } =
    useInfiniteQuery<SubscriberCommentsResponse>(
      generateSubscriberCommentsKey({ commentType, userId, username }),
      ({ pageParam = 1 }) =>
        getPaginatedSubscriberComments({
          comment_type: commentType,
          page: pageParam,
          username,
          user_id: userId,
        }),
      {
        getNextPageParam: (lastPage) => lastPage.nextPage,
      }
    );

  return { data, isLoading, isFetching, fetchNextPage, hasNextPage };
}
